<template lang="pug">
.vcontent
  .desc
    a(href="http://mp.weixin.qq.com/s?__biz=MzI5ODY0NTAxNA==&sn=9a2ae8993e1c62d5ee9b89a03e8ca2ce&mid=2247483706&idx=1" target="_blank")
      | <b>我们为什么要创建前沿社：</b>
      | 那群快速自我迭代的成功者身上到底有哪些共性的“赢家特质”？
      .triangle-right
  img.go(src='../assets/imgs/go.jpg', alt='我们曾抵达...')
</template>

<script>
export default {
  name: 'vcontent',
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.vcontent
  .desc
    text-align center
    background #F1F1F1
    padding 40px 0 33px
    a
      font-size 24px
      color #000
      b
        font-weight 800
      &:hover
        color #5FC4FF

      .triangle-right
        display inline-block
        vertical-align top
        margin .1em .3em
        width 0
        height 0
        border-top .4em solid transparent
        border-left .5em solid currentColor
        border-bottom .4em solid transparent

  .go
    width 100%
    max-width 1920px
    display inline-block
    vertical-align bottom

</style>



// WEBPACK FOOTER //
// Content.vue?5f956dcc